/* global Conf */
import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../../constants/default_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../../input/date'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import RegionsInput from '../../input/regions'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import UploadInput from '../../input/upload'
import filesize from 'file-size'
import moment from 'moment'
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap'

const ValidityField = ({ attr, val, store }) => {
  function errorDesc(e) {
    if (e.url) {
      return `missing: ${e.url}`
    }
    return JSON.stringify(e)
  }

  switch (val) {
  case undefined:
  case null:
    return (<span>?</span>)
  case 'inactive':
    return (
      <OverlayTrigger placement='right' overlay={
        <Tooltip>{store.__('This video file may be inactive. Delete it or cancel inactive validity.')}</Tooltip>
      }><span className='text-danger one-line-value'>
          <span className='glyphicon glyphicon-warning-sign' />&nbsp;{store.__('inactive')}
        </span>
      </OverlayTrigger>
    )
  case 'ok':
  case '[]':
    return <span className='glyphicon glyphicon-ok' />
  default: {
    try {
      val = val && JSON.parse(val)
    } catch (e) {
      return (<span>?</span>)
    }
    const tooltipContent = val && (
      <Tooltip id={`tooltip${attr}`} className='uplerror'>
        <ul>
          {
            val.map((i, idx) => {
              return <li key={idx}>{errorDesc(i)}</li>
            })
          }
        </ul>
      </Tooltip>
    )
    return (
      val && <OverlayTrigger placement='right' overlay={tooltipContent}>
        <span className='glyphicon glyphicon-exclamation-sign' />
      </OverlayTrigger>
    )
  }
  }
}

const FPUploads = ({ store, uploadType, ...rest }) => {
  const entity = store.cv.record
  // const MAXPREVIEW = 4 * 1024 * 1024
  const IN_PROGRESS_STATE = [
    defaultConst.STATES_UPLOAD.UPLOADING,
    defaultConst.STATES_UPLOAD.CANCELLED,
    defaultConst.STATES_UPLOAD.WAITING
  ]

  const PreviewField = observer(({ row }) => {
    if (IN_PROGRESS_STATE.indexOf(row.state) >= 0 || defaultConst.VIDEO_TYPES.indexOf(row.file_type) >= 0 || defaultConst.SUBTITLES_TYPES.indexOf(row.file_type) >= 0) {
      return null // no preview for videos
    }

    return (<div>
      <OverlayTrigger placement={'left'}
        overlay={<Tooltip>{
          !defaultConst.UPLOAD_ARTWORKS_SMALL[row.file_type]
            ? store.__('No image availible')
            : <img alt='Image' className="upload-thumbnails" src={
              defaultConst.UPLOAD_ARTWORKS_FILENAME + row.s3_filename +
              defaultConst.UPLOAD_ARTWORKS_SMALL[row.file_type]} />}
        </Tooltip>}>
        <Button style={{ outline: 'none', cursor: 'default' }}>
          <i className='glyphicon glyphicon-picture' />
        </Button>
      </OverlayTrigger>&nbsp;

      <OverlayTrigger placement={'right'} overlay={<Tooltip>{store.__('High resolution download')}</Tooltip>}>
        <Button style={{ outline: 'none', cursor: 'pointer' }}
          disabled={!defaultConst.UPLOAD_ARTWORKS_FULL[row.file_type]}
          href={defaultConst.UPLOAD_ARTWORKS_FILENAME + row.s3_filename + defaultConst.UPLOAD_ARTWORKS_FULL[row.file_type]}
          target='_blank'><i className='glyphicon glyphicon-cloud-download' />
        </Button>
      </OverlayTrigger>&nbsp;

      {row.dominant_color && <OverlayTrigger placement={'right'} overlay={<Tooltip>{store.__('Dominant color') + ': ' + row.dominant_color}</Tooltip>}>
        <Button style={{ outline: 'none', cursor: 'pointer' }}>
          <i className='glyphicon glyphicon-stop' style={{ color: row.dominant_color }} />
        </Button>
      </OverlayTrigger>
      }
    </div>)
  })

  const FPUploadForm = observer(({ record, state, updateFormField, errors }) => {
    function showOnlyFileInput() {
      return IN_PROGRESS_STATE.indexOf(record.get('state')) >= 0
    }

    const hasID = record.has('id')
    const addSubtitles = record.has('addSubtitles')
    const { stageOneRestricted, stageTwoRestricted } = store.timeRestriction.checkSubentity(store, state)
    const dateRestriction = store.timeRestriction.uploads
    const items = store.cv.uploads
    const hasChildrens = hasID && items.some(i => record.get('id') === i.parent_id)
    const uploadType = record.has('extraParam') && Object.prototype.hasOwnProperty.call(record.get('extraParam'), 'uploadType') && record.get('extraParam').uploadType
    // add uploads to the options
    store.options.set('uploads', items)

    return (
      <div className='row'>
        {store.lastSavedSubEntity && state.lastSave && store.lastSavedSubEntity[state.lastSave] &&
          ((store.lastSavedSubEntity[state.lastSave].parent_id && uploadType === 'subtitle') ||
            (!store.lastSavedSubEntity[state.lastSave].parent_id && uploadType !== 'subtitle')) &&
          <div className='col-xs-12'>
            <Button bsStyle='primary' onClick={() => store.loadLastSavedSubentity(state)} disabled={stageOneRestricted}>
              {store.__('+ Load data from the last saved item')}
            </Button><br />&nbsp;
          </div>
        }
        <div className='col-xs-12'>
          <SelectInput label={store.__('file type')} disabled={stageOneRestricted || hasID || addSubtitles}
            attr={'file_type'} record={record}
            onChange={updateFormField} optionsrecord={store.options}
            optionsattr={'UploadTypes'}
            valueFilterFc={!record.has('id') && (uploadType === 'subtitle' || addSubtitles)
              ? i => defaultConst.SUBTITLES_TYPES.indexOf(i.value) < 0
              : (!record.has('id') ? i => defaultConst.SUBTITLES_TYPES.indexOf(i.value) >= 0 || defaultConst.PPROLLS_TYPES.indexOf(i.value) >= 0 : undefined)
            }
            labelattr='text' valueattr='value' errors={errors} />

          {record.has('file_type') && record.get('file_type') && defaultConst.SUBTITLES_TYPES.indexOf(record.get('file_type')) >= 0 &&
            <SelectInput label={store.__('Assign to feature/preview')} attr={'parent_id'} record={record}
              onChange={updateFormField} optionsrecord={store.options}
              optionsattr={'uploads'} disabled={stageOneRestricted || hasID || addSubtitles}
              valueFilterFc={i => (moment().isAfter(moment(i.valid_to), 'day') ||
                (record.get('file_type').indexOf(defaultConst.SUBTITLES_TYPES[0]) >= 0
                  ? i.file_type !== defaultConst.VIDEO_TYPES[0]
                  : i.file_type !== defaultConst.VIDEO_TYPES[1]))}
              valueattr='id' labelattr={i => { return i.id + ' | ' + i.lang + ' | ' + i.s3_filename + ' | ' + i.original_filename }} errors={errors} />
          }
          {!showOnlyFileInput()
            ? (<div>
              <SelectInput label={store.__('lang')}
                attr={'lang'} record={record}
                onChange={updateFormField} optionsrecord={store.options}
                optionsattr={'Languages'}
                disabled={stageOneRestricted || hasID}
                labelattr='text' valueattr='value' errors={errors} />
              <RegionsInput label={store.__('regions')} attr={'regions'} disabled={stageOneRestricted || hasChildrens}
                record={record} onChange={updateFormField} errors={errors}
                optionsrecord={store.options} optionsattr={'Countries'} />
              <DateInput label={store.__('valid from')} attr={'valid_from'}
                disabled={stageOneRestricted || hasChildrens || (hasID && record.get('valid_from') && moment(record.get('valid_from')).isSame(moment(), 'day'))}
                minDate={dateRestriction.valid_from.minDate}
                record={record} onChange={updateFormField} errors={errors} />
              <DateInput label={store.__('valid to')} attr={'valid_to'} disabled={stageTwoRestricted || hasChildrens}
                record={record} onChange={updateFormField} errors={errors}
                minDate={dateRestriction.valid_to.minDateToday &&
                  (!hasID || !record.get('id') || (record.has('valid_from') && record.get('valid_from') &&
                    moment(record.get('valid_from')).isSameOrAfter(dateRestriction.valid_to.minDateToday, 'day')))
                  ? dateRestriction.valid_to.minDateToday
                  : dateRestriction.valid_to.minDate}
              />
            </div>)
            : null}
          {store.showFileBrowse(record) && !record.has('loadedfromcopy')
            ? <UploadInput record={record} attr='file' disabled={stageOneRestricted}
              label={store.__('file')} onChange={updateFormField} errors={errors} />
            : <div>
              <TextInput disabled
                type='text' label={store.__('Original filename')} attr={'original_filename'}
                record={record} errors={errors} />
              <TextInput disabled
                type='text' label={store.__('S3 filename')} attr={'s3_filename'}
                record={record} errors={errors} />
              {record.get('dominant_color') ? <TextInput disabled
                style={{ backgroundColor: record.get('dominant_color') }}
                type='text' label={store.__('Dominant color of the uploaded image')} attr={'dominant_color'}
                record={record} errors={errors} /> : null}
            </div>}
          {hasChildrens &&
            <div>
              <strong>{store.__('Subtitles')}</strong>
              <ul>
                {items
                  .filter(i => record.get('id') === i.parent_id)
                  .map(i => { return <li key={i.id}>{i.id} | {i.lang} | {i.regions} | {i.s3_filename} | {i.original_filename}</li> })}
              </ul>
            </div>}

        </div>
      </div>
    )
  })

  function customListActions(row) {
    const actions = []
    if (defaultConst.VIDEO_TYPES.indexOf(row.file_type) >= 0 && (
      row.state === 'uploaded' ||
      (row.file_type === 'feature' && (
        row.state === 'download-encoded' || row.state === 'stream-encoded' ||
        row.state === 'stream-error' || row.state === 'encoded')) ||
      row.state.indexOf('"failed":"') >= 0 ||
      row.state.indexOf('encoding error') >= 0
    )) { // video and not being encoded
      if (row.file_type === 'feature') {
        // all encoding
        (row.state === 'uploaded' || row.state.indexOf('encoding error') >= 0) &&
          actions.push({
            label: <span><span className='glyphicon glyphicon-film' />&nbsp; {store.__('Encode for download and stream')} </span>,
            onClick: () => store.encodeVideo(row, 'all-encoding')
          })
        // download encoding
        row.state !== 'encoded' &&
          row.state !== 'download-encoded' &&
          row.state !== 'stream-error' &&
          actions.push({
            label: <span><span className='glyphicon glyphicon-compressed' />&nbsp; {store.__('Encode for download')} </span>,
            onClick: () => store.encodeVideo(row, 'download-encoding')
          })
        // stream encoding
        row.state !== 'encoded' &&
          row.state !== 'stream-encoded' &&
          row.state !== 'uploaded' &&
          row.state !== 'encoding error' &&
          actions.push({
            label: <span><span className='glyphicon glyphicon-compressed' />&nbsp; {store.__('Encode for stream')} </span>,
            onClick: () => store.encodeVideo(row, 'stream-encoding')
          })
      } else {
        actions.push({
          label: <span><span className='glyphicon glyphicon-compressed' />&nbsp; {store.__('Encode')} </span>,
          onClick: () => store.encodeVideo(row)
        })
      }
    }

    if (defaultConst.SUBTITLES_TYPES.indexOf(row.file_type) < 0) {
      actions.push({
        label: <span><span className='glyphicon glyphicon-duplicate' />&nbsp; {store.__('Copy')} </span>,
        onClick: () => {
          const { id, valid_from, valid_to, ...rowWithoutDates } = row

          const state = store.cv.subentities.uploads
          store.onSubentityEdit(store.cv.subentities.uploads, store.cv.uploads, null)

          if (rowWithoutDates) {
            Object.keys(rowWithoutDates).forEach(k => state.record.set(k, rowWithoutDates[k]))
            state.record.set('control_timestamp', Math.round(new Date().getTime()))
            state.record.set('loadedfromcopy', true)
            store._runSubentityValidators(state)
            store.addMessage('copies row was retrieved', 'info', 3000)
          }
        },
        persistant: true // show even for restricted items
      })
    }

    if (defaultConst.VIDEO_TYPES.indexOf(row.file_type) >= 0) {
      // add subtitles
      actions.push({
        label: <span><span className='glyphicon glyphicon-subtitles' />&nbsp;  {store.__('Add subtitles')} </span>,
        onClick: () => {
          store.onSubentityEdit(store.cv.subentities.uploads, store.cv.uploads, {
            control_timestamp: Math.round(new Date().getTime()),
            file_type: (row.file_type.indexOf(defaultConst.VIDEO_TYPES[0]) >= 0 ? defaultConst.SUBTITLES_TYPES[0] : defaultConst.SUBTITLES_TYPES[1]),
            lang: row.lang,
            parent_id: row.id,
            platform: row.platform,
            regions: row.regions,
            slug: row.slug,
            video_id: row.video_id,
            valid_from: moment(row.valid_from) < moment() ? moment().format(defaultConst.DATE_FORMAT) : row.valid_from,
            valid_to: row.valid_to,
            addSubtitles: true
          })
        }
      })

      // restore file
      row.validity === 'inactive'
        ? actions.push({
          label: <span><span className='glyphicon glyphicon-warning-sign' />&nbsp;  {store.__('Cancel "inactive" validity')} </span>,
          onClick: () => {
            window.confirm(store.__('Are you sure to cancel "inactive" validity?')) &&
              store.cv.cancelValidity(row.id)
          },
          persistant: true
        }) : null

      const s3path = row.file_type + '/' + (row.s3_filename && row.s3_filename.indexOf('/') > 1
        ? row.s3_filename.substr(0, row.s3_filename.indexOf('/'))
        : row.s3_filename)

      // archive file
      row.state === 'encoded'
        ? actions.push({
          label: <span><span className='glyphicon glyphicon-floppy-save' />&nbsp;  {store.__('Archive this file')} </span>,
          onClick: () => {
            window.confirm(store.__('Are you sure to archive this file?')) &&
              store.cv.archiveAsset(row.id, s3path)
          },
          persistant: true
        }) : null

      // restore file
      row.state === 'archived'
        ? actions.push({
          label: <span><span className='glyphicon glyphicon-floppy-open' />&nbsp;  {store.__('Restore this file')} </span>,
          onClick: () => {
            window.confirm(store.__('Are you sure to restore this file?')) &&
              store.cv.restoreAsset(row.id, s3path)
          },
          persistant: true
        }) : null

      // delete file
      row.state === 'encoded' && (moment(row.valid_to).isBefore(moment(), 'day') || moment(row.valid_from).isSameOrAfter(moment(), 'day'))
        ? actions.push({
          label: <span><span className='glyphicon glyphicon-trash' />&nbsp;  {store.__('Delete this file')} </span>,
          onClick: () => {
            window.confirm(store.__('Are you sure to delete this file?')) &&
              store.cv.deleteAsset(row.id, s3path)
          },
          persistant: true
        }) : null
    }

    return actions
  }

  return entity.get('id') === undefined ? (
    <div>{store.__('Film not saved thus no uploads available')}</div>
  ) : (
    <EmbededEntityInput
      store={store}
      attr={'uploads'}
      items={store.cv.uploads}
      onAddRow={(upload) => store.saveUpload(upload)}
      onUpdateRow={store.saveUpload.bind(store)}
      onDeleteRow={store.removeUpload.bind(store)}
      edit_title={store.__('edit FlyPrivate upload item')}
      add_title={store.__('add FlyPrivate upload item')}
      sortUploads={true}
      filter={uploadType === 'subtitle' ? i => i.parent_id > 0 : i => !i.parent_id}
      removeCount={uploadType !== 'subtitle'
        ? store.cv.uploads.filter(i => i.parent_id > 0).length
        : store.cv.uploads.filter(i => !i.parent_id).length}
      fields={[
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<OptionsField attr={attr} val={row[attr]}
          options={store.options.get('UploadTypes')}
          labelattr='text' />),
        (attr, row) => (<span>{row.parent_id > 0
          ? store.cv.uploads.filter(i => i.id === row.parent_id).map(i => { return i.id + ' - ' + i.file_type })
          : ''}
        </span>),
        (attr, row) => (<span>
          {store.cv.uploads.filter(i => i.parent_id === row.id).map(i => { return i.lang }).join(', ')}
        </span>),
        (attr, row) => {
          try {
            const status = JSON.parse(row[attr])
            if (status.failed) {
              return <TextField attr={attr} val={store.__('failed')} />
            }
            return <TextField attr={attr} val={status.step} />
          } catch (_) {
            if (store.isFileMissing(row) || (row.state && row.state === defaultConst.UPLOAD_FILE_MISSING)) {
              return <span className='text-danger'>{store.__(defaultConst.UPLOAD_FILE_MISSING)}</span>
            } else {
              return <TextField attr={attr} val={row[attr]} />
            }
          }
        },
        (attr, row) => (<ValidityField attr={attr} val={row[attr]} store={store} />),
        (attr, row) => (<PreviewField attr='preview' row={row} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<OptionsField attr={attr} val={row[attr]}
          options={store.options.get('Languages')}
          labelattr='text' />),
        (attr, row) => (<span title={row[attr] > 0
          ? row[attr] + ' B = ' + filesize(row[attr]).human()
          : '0 B'}>{filesize(row[attr]).human('si')}</span>),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_to} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_from} />)
      ]}
      customRowStyleClass={row => {
        if (row.file_type) {
          let addClass = ''

          if (defaultConst.SUBTITLES_TYPES.indexOf(row.file_type) >= 0) {
            addClass = ' active '
          }
          if (row.state === 'encoded' || (defaultConst.VIDEO_TYPES.indexOf(row.file_type) < 0 && row.state === 'uploaded')) {
            addClass = (defaultConst.VIDEO_TYPES.indexOf(row.file_type) >= 0 && row.file_type.indexOf('feature') >= 0
              ? ' info '
              : (defaultConst.VIDEO_TYPES.indexOf(row.file_type) >= 0 ? ' success ' : (addClass || ' warning ')))
          } else if (row.state === 'waiting' || row.state === 'uploading') {
            addClass = ''
          } else if (row.state === 'failed' || row.state === 'canceled') {
            addClass = ' danger '
          }

          return addClass
        }
      }}
      rowId={(row) => (row.id)}
      extraParam={{ extraTitle: uploadType, uploadType: uploadType }}
      EditForm={FPUploadForm}
      customListActions={customListActions} {...rest}
    />
  )
}
export default observer(FPUploads)
